import Header from '../components/Header';
import Footer from '../components/Footer';
import FadeInSection from '../components/FadeInSection';
import TheApp from '../components/TheApp';
import { useState } from 'react';
import { Helmet } from "react-helmet-async";

export default function ForBrands() {
    const [isChecked, setIsChecked] = useState(true);
  const isLaunched = false;

const products = [
    {
      id: 1,
      brand: "Pink set",
      price: "₹ 6999",
    
      image: "https://images.unsplash.com/photo-1591047139829-d91aecb6caea?auto=format&fit=crop&q=80&w=400"
    },
    {
      id: 2,
      brand: "Footwear",
      price: "₹ 1500",
      image: "https://images.unsplash.com/photo-1509631179647-0177331693ae?auto=format&fit=crop&q=80&w=400"
    },
    {
      id: 3,
      brand: "Necklace",
      price: "₹ 699",
      image: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?auto=format&fit=crop&q=80&w=400"
    },
  
     {
      id: 5,
      brand: "Bracelet",
      price: "₹ 700",
      image: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?auto=format&fit=crop&q=80&w=400"
    },
     {
      id: 6,
      brand: "Bag",
      price: "₹ 2699",
      image: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?auto=format&fit=crop&q=80&w=400"
    },
     {
      id: 7,
      brand: "Glasses",
      price: "₹ 3700",
      image: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?auto=format&fit=crop&q=80&w=400"
    }
  ];

  return (
    <>

     <Helmet>
            <title>OutfitFind Brands| Discover Fashion, Outfits & Style </title>
           <meta
            name="description"
            content="Discover trending fashion, stylish outfits, and must-have looks on OutfitFind. Find your style and shop your favorite fashion online."
          />
                </Helmet>

      <Header />
      <main>
        <section className="brands-section" style={{ paddingTop: '10rem' }}>
          <div className="container">
            <div className="brands-header">
              <div className="section-eyebrow">Partner With OUTFITFIND</div>
              <h2 className="section-title">To Put you brand <span className="italic">inside the complete look.</span></h2>
              <p className="section-subtitle">OutfitFind showcases your products inside professionally styled outfits, helping customers discover your brand as part of a complete look.</p>
            </div>

            <FadeInSection className="benefits-grid">
              <div className="benefit-card">
                <div className="benefit-icon"><i className="bi bi-eye"></i></div>
                <h4 className="benefit-title"> INCREASED BRAND VISIBILITY</h4>
                <p className="benefit-description">Get discovered through professionally styled outfits across different occasions and aesthetics.</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon"><i className="bi bi-star"></i></div>
                <h4 className="benefit-title">PREMIUM EDITORIAL PRESENTATION</h4>
                <p className="benefit-description">Your products are showcased as part of complete, professionally styled looks.</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon"><i className="bi bi-graph-up-arrow"></i></div>
                <h4 className="benefit-title">HIGH-INTENT TRAFFIC</h4>
                <p className="benefit-description">Users can move directly from an outfit to your product page within OutfitFind.</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon"><i className="bi bi-shield-check"></i></div>
                <h4 className="benefit-title">YOUR LOGISTICS STAY THE SAME</h4>
                <p className="benefit-description">OutfitFind helps customers discover your products without changing the way your brand manages orders, fulfilment or delivery.</p>
              </div>

            
            </FadeInSection>

          


        <section className="brand-section">
      <div className="container">
        
        {/* Section Heading */}
        <div className="text-center mb-5">
          <span className="section-tag">VISUAL DISCOVERY</span>
          <h2 className="section-title display-5 mt-2">
            HOW YOUR BRAND APPEARS ON <span>OUTFITFIND</span>
          </h2>
        </div>

        {/* Visual Showcase Row */}
        <div className="row g-4 align-items-center mb-5">
          
          {/* Column 1: Main Styled Outfit */}


         <div className="col-lg-6">
              <div className="styled-look-card">
                <div className="styled-image-wrapper">
                  <img
                    src="../../img/brand.webp"
                    className="img-fluid w-100 styled-look-img"
                    alt="The Complete Styled Look"
                  />
                  <div className="look-badge-overlay">
                    

                    <span className="look-number-tag">Summer Fit</span>
                    <h4 className="look-title">Summer Vacay Fit</h4>
                    <p className="look-stylist mb-0">Under Rs.9,000/-</p>
                  </div>
                </div>
              </div>
            </div>

        

          {/* Column 2: Highlighted Featured Products */}
          <div className="col-lg-6">
            <div className="mb-3">
              <p className="text-uppercase text-muted fw-bold mb-3" style={{ fontSize: '0.75rem', letterSpacing: '1.5px' }}>
                Featured Products in Outfit
              </p>
              {products.map((item) => (
                 <div key={item.id} className="app-cart-item mb-2 product-card " >
                        <div className="form-check custom-checkbox me-2" >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={isChecked}
                            onChange={(e) => setIsChecked(e.target.checked)}
                            id={`check-${item.id}`}
                          />
                          <label className="form-check-label" htmlFor={`check-${item.id}`}></label>
                        </div>
                        <div className="app-item-details">
                        
                          <h6 className="title">{item.brand}</h6>
                         
                        </div>
                        <span className="app-item-price">{item.price}</span>
                      </div>
               
              ))}
            </div>
          </div>

        

        </div>

        {/* Minimal Visual Journey Bar */}
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="journey-container d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div className="journey-step">
                <div className="journey-dot"></div>
                <span>Brand Product</span>
              </div>
              <span className="journey-arrow">→</span>
              <div className="journey-step">
                <div className="journey-dot"></div>
                <span>styled into a complete outfit</span>
              </div>
              <span className="journey-arrow">→</span>
              <div className="journey-step">
                <div className="journey-dot"></div>
                <span>Discovered by user</span>
              </div>
              <span className="journey-arrow">→</span>
              <div className="journey-step">
                <div className="journey-dot"></div>
                <span>Product page opened within OutfitFind</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>



            <FadeInSection className="partnership-form">
              <h3 className="text-center mb-4" style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '2.5rem', color: 'var(--cream)' }}>Partnership Form</h3>
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="row g-4">
                  <div className="col-md-6">
                    <label className="form-label-custom">Brand Name</label>
                    <input type="text" className="form-control-custom" placeholder="Your brand" required />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label-custom">Contact Person</label>
                    <input type="text" className="form-control-custom" placeholder="Your name" required />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label-custom">Email Address</label>
                    <input type="email" className="form-control-custom" placeholder="you@brand.com" required />
                  </div>
                    <div className="col-md-6">
                    <label className="form-label-custom">Instagram</label>
                    <input type="url" className="form-control-custom" placeholder="Instagram Url" required />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label-custom">Website</label>
                    <input type="url" className="form-control-custom" placeholder="www.brand.com"  />
                  </div>

                  <div className="col-12">
                    <label className="form-label-custom">Tell us about your brand</label>
                    <textarea className="form-control-custom" placeholder="Tell us about your brand philosophy and products..." ></textarea>
                  </div>
                  <div className="col-12 text-center mt-4">
                    <button type="submit" className="btn-peach"><span>SUBMIT PARTNERSHIP REQUEST</span></button>
                  </div>
                </div>
              </form>
            </FadeInSection>
          </div>
        </section>

  <TheApp />

     <section className="cta-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10 text-center">
            
            <div className="cta-card">
              {/* Question Heading */}
              <h2 className="cta-heading">
                Want to see <span>OutfitFind</span> in action?
              </h2>

              {/* Status / Button Container */}
              <div className="d-flex justify-content-center mt-3">
                {!isLaunched ? (
                  /* FOR NOW: COMING SOON STATE */
                  <div className="cta-badge-pill">
                    <i className="bi bi-clock-history"></i>
                    <span>APP COMING SOON</span>
                  </div>
                ) : (
                  /* AFTER LAUNCH: LIVE LINK STATE */
                  <a href="https://outfitfind.app" className="btn-cta-explore">
                    <span>EXPLORE THE APP</span>
                    <i className="bi bi-arrow-right"></i>
                  </a>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

          
      </main>
      <Footer />
    </>
  );
}